import { render, staticRenderFns } from "./DashboardInfoBox.vue?vue&type=template&id=c3bfe6f0&scoped=true"
import script from "./DashboardInfoBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardInfoBox.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DashboardInfoBox.vue?vue&type=style&index=0&id=c3bfe6f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bfe6f0",
  null
  
)

export default component.exports